import React from 'react';
import { ui, type Tone } from '../ui';

/** Status pill with a semantic tone; colours follow the theme. */
export const Pill: React.FC<{ tone?: Tone; children: React.ReactNode; title?: string }> = ({ tone = 'neutral', children, title }) => <span style={ui.pill(tone)} title={title}>{children}</span>;
